<template>
  <div>
      <full-page  ref="fullpagePhotos" :options="options" id="fullpage">

        <div id="section000"  class="section">
          <h2>LOADING...</h2>

        </div>


        <div id="section87" class="section">

          <div class="photoPad">
          <b-container class="h-100">
            <b-row class="h-100 justify-content-center">
              <b-col><h1>Photos</h1></b-col>
            </b-row>
            <b-row class="h-100 justify-content-center">
              <b-col lg="10" xl="12">
                <b-card-group deck class="mb-3">
                  <b-card class="text-center">
                    <a href="#photo2">
                      <b-img src="../../static/img/TMBcharacterPhotos_0000_shadowMoon.jpg" fluid />
                    </a>
                  </b-card>
                  <b-card class="text-center">
                    <a href="#photo3">
                      <b-img src="../../static/img/TMBcharacterPhotos_0001_shadowMoon.jpg" fluid />
                    </a>
                  </b-card>
                  <b-card class="text-center">
                    <a href="#photo4">
                      <b-img src="../../static/img/TMBcharacterPhotos_0002_shadowMoon.jpg" fluid />
                    </a>
                  </b-card>
              </b-card-group>

                <b-card-group deck class="mb-3">
                  <b-card class="text-center">
                    <a href="#photo5">
                      <b-img src="../../static/img/TMBcharacterPhotos_0000_mrWedensday.jpg" fluid />
                    </a>
                  </b-card>
                  <b-card class="text-center">
                    <a href="#photo6">
                      <b-img src="../../static/img/TMBcharacterPhotos_0001_mrWedensday.jpg" fluid />
                    </a>
                  </b-card>
                  <b-card class="text-center">
                    <a href="#photo7">
                      <b-img src="../../static/img/TMBcharacterPhotos_0002_mrWedensday.jpg" fluid />
                    </a>
                  </b-card>
              </b-card-group>


                <b-card-group deck class="mb-3">
                  <b-card class="text-center">
                     <a href="#photo8">
                      <b-img src="../../static/img/TMBcharacterPhotos_0000_lauraMoon.jpg" fluid />
                     </a>
                  </b-card>
                  <b-card class="text-center">
                     <a href="#photo9">
                      <b-img src="../../static/img/TMBcharacterPhotos_0001_lauraMoon.jpg" fluid />
                     </a>
                  </b-card>
                  <b-card class="text-center">
                     <a href="#photo10">
                      <b-img src="../../static/img/TMBcharacterPhotos_0002_lauraMoon.jpg" fluid />
                     </a>
                  </b-card>
              </b-card-group>

              <b-card-group deck class="mb-3">
                  <b-card class="text-center">
                     <a href="#photo11">
                      <b-img src="../../static/img/TMBcharacterPhotos_0000_madSweeney.jpg" fluid />
                     </a>
                  </b-card>
                  <b-card class="text-center">
                     <a href="#photo12">
                      <b-img src="../../static/img/TMBcharacterPhotos_0001_madSweeney.jpg" fluid />
                     </a>
                  </b-card>
                  <b-card class="text-center">
                     <a href="#photo13">
                      <b-img src="../../static/img/TMBcharacterPhotos_0002_madSweeney.jpg" fluid />
                     </a>
                  </b-card>
              </b-card-group>


              <b-card-group deck class="mb-3">
                  <b-card class="text-center">
                    <a href="#photo14">
                      <b-img src="../../static/img/TMBcharacterPhotos_0000_mrIbis.jpg" fluid />
                    </a>
                  </b-card>
                  <b-card class="text-center">
                    <a href="#photo15">
                      <b-img src="../../static/img/TMBcharacterPhotos_0001_mrIbis.jpg" fluid />
                    </a>
                  </b-card>
                  <b-card class="text-center">
                    <a href="#photo16">
                      <b-img src="../../static/img/TMBcharacterPhotos_0002_mrIbis.jpg" fluid />
                    </a>
                  </b-card>
              </b-card-group>

              <b-card-group deck class="mb-3">
                  <b-card class="text-center">
                    <a href="#photo17">
                      <b-img src="../../static/img/TMBcharacterPhotos_0000_salim.jpg" fluid />
                    </a>
                  </b-card>
                  <b-card class="text-center">
                    <a href="#photo18">
                      <b-img src="../../static/img/TMBcharacterPhotos_0001_salim.jpg" fluid />
                    </a>
                  </b-card>
                  <b-card class="text-center">
                    <a href="#photo19">
                      <b-img src="../../static/img/TMBcharacterPhotos_0002_salim.jpg" fluid />
                    </a>
                  </b-card>
              </b-card-group>

              <b-card-group deck class="mb-3">
                  <b-card class="text-center">
                    <a href="#photo20">
                      <b-img src="../../static/img/TMBcharacterPhotos_0000_theJinn.jpg" fluid />
                    </a>
                  </b-card>
                  <b-card class="text-center">
                    <a href="#photo21">
                      <b-img src="../../static/img/TMBcharacterPhotos_0001_theJinn.jpg" fluid />
                    </a>
                  </b-card>
                  <b-card class="text-center">
                    <a href="#photo22">
                      <b-img src="../../static/img/TMBcharacterPhotos_0002_theJinn.jpg" fluid />
                    </a>
                  </b-card>
              </b-card-group>


              <b-card-group deck class="mb-3">
                  <b-card class="text-center">
                    <a href="#photo23">
                      <b-img src="../../static/img/TMBcharacterPhotos_0000_mrNancy.jpg" fluid />
                    </a>
                  </b-card>
                  <b-card class="text-center">
                    <a href="#photo24">
                      <b-img src="../../static/img/TMBcharacterPhotos_0001_mrNancy.jpg" fluid />
                    </a>
                  </b-card>
                  <b-card class="text-center">
                    <a href="#photo25">
                      <b-img src="../../static/img/TMBcharacterPhotos_0002_mrNancy.jpg" fluid />
                    </a>
                  </b-card>
              </b-card-group>



              <b-card-group deck class="mb-3">
                  <b-card class="text-center">
                    <a href="#photo26">
                      <b-img src="../../static/img/TMBcharacterPhotos_0000_Bilquis.jpg" fluid />
                    </a>
                  </b-card>
                  <b-card class="text-center">
                    <a href="#photo27">
                      <b-img src="../../static/img/TMBcharacterPhotos_0001_Bilquis.jpg" fluid />
                    </a>
                  </b-card>
                  <b-card class="text-center">
                    <a href="#photo28">
                      <b-img src="../../static/img/TMBcharacterPhotos_0002_Bilquis.jpg" fluid />
                    </a>
                  </b-card>
              </b-card-group>


              <b-card-group deck class="mb-3">
                  <b-card class="text-center">
                    <a href="#photo29">
                      <b-img src="../../static/img/TMBcharacterPhotos_0000_techBoy.jpg" fluid />
                    </a>
                  </b-card>
                  <b-card class="text-center">
                    <a href="#photo30">
                      <b-img src="../../static/img/TMBcharacterPhotos_0001_techBoy.jpg" fluid />
                    </a>
                  </b-card>
                  <b-card class="text-center">
                    <a href="#photo31">
                      <b-img src="../../static/img/TMBcharacterPhotos_0002_techBoy.jpg" fluid />
                    </a>
                  </b-card>
              </b-card-group>


              <b-card-group deck class="mb-3">
                  <b-card class="text-center">
                    <a href="#photo32">
                      <b-img src="../../static/img/TMBcharacterPhotos_0000_mrWorld.jpg" fluid />
                    </a>
                  </b-card>
                  <b-card class="text-center">
                    <a href="#photo33">
                      <b-img src="../../static/img/TMBcharacterPhotos_0001_mrWorld.jpg" fluid />
                    </a>
                  </b-card>
                  <b-card class="text-center">
                    <a href="#photo34">
                      <b-img src="../../static/img/TMBcharacterPhotos_0002_mrWorld.jpg" fluid />
                    </a>
                  </b-card>
              </b-card-group>


              </b-col>
            </b-row>
          </b-container>
          </div>
         <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />

        </div>

          <div id="section88" class="section">
             <a  href="#photo1" class="photoNav">Back to Top</a>
             <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>

          <div id="section89" class="section">
             <a  href="#photo1" class="photoNav">Back to Top</a>              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>

          <div id="section90" class="section">
             <a  href="#photo1" class="photoNav">Back to Top</a>              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>


          <div id="section91" class="section">
             <a  href="#photo1" class="photoNav">Back to Top</a>              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>

          <div id="section92" class="section">
             <a  href="#photo1" class="photoNav">Back to Top</a>              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>

          <div id="section93" class="section">
             <a  href="#photo1" class="photoNav">Back to Top</a>              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>


          <div id="section94" class="section">
             <a  href="#photo1" class="photoNav">Back to Top</a>              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>

          <div id="section95" class="section">
             <a  href="#photo1" class="photoNav">Back to Top</a>              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>

          <div id="section96" class="section">
             <a  href="#photo1" class="photoNav">Back to Top</a>              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>

          <div id="section97" class="section">
             <a  href="#photo1" class="photoNav">Back to Top</a>              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>

          <div id="section98" class="section">
             <a  href="#photo1" class="photoNav">Back to Top</a>              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>

          <div id="section99" class="section">
             <a  href="#photo1" class="photoNav">Back to Top</a>              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>



          <div id="section100" class="section">
             <a  href="#photo1" class="photoNav">Back to Top</a>              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>

          <div id="section101" class="section">
             <a  href="#photo1" class="photoNav">Back to Top</a>              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>

          <div id="section102" class="section">
             <a  href="#photo1" class="photoNav">Back to Top</a>              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>


          <div id="section103" class="section">
             <a  href="#photo1" class="photoNav">Back to Top</a>              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>

          <div id="section104" class="section">
             <a  href="#photo1" class="photoNav">Back to Top</a>              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>

          <div id="section105" class="section">
             <a  href="#photo1" class="photoNav">Back to Top</a>              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>


          <div id="section106" class="section">
             <a  href="#photo1" class="photoNav">Back to Top</a>              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>

          <div id="section107" class="section">
             <a  href="#photo1" class="photoNav">Back to Top</a>              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>

          <div id="section108" class="section">
             <a  href="#photo1" class="photoNav">Back to Top</a>              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>


          <div id="section109" class="section">
             <a  href="#photo1" class="photoNav">Back to Top</a>              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>

          <div id="section110" class="section">
             <a  href="#photo1" class="photoNav">Back to Top</a>              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>

          <div id="section111" class="section">
             <a  href="#photo1" class="photoNav">Back to Top</a>              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>


          <div id="section112" class="section">
             <a  href="#photo1" class="photoNav">Back to Top</a>              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>

          <div id="section113" class="section">
             <a  href="#photo1" class="photoNav">Back to Top</a>              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>

          <div id="section114" class="section">
             <a  href="#photo1" class="photoNav">Back to Top</a>              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>


          <div id="section115" class="section">
             <a  href="#photo1" class="photoNav">Back to Top</a>              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>

          <div id="section116" class="section">
             <a  href="#photo1" class="photoNav">Back to Top</a>              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>

          <div id="section117" class="section">
             <a  href="#photo1" class="photoNav">Back to Top</a>              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>

          <div id="section118" class="section">
             <a  href="#photo1" class="photoNav">Back to Top</a>              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>

          <div id="section119" class="section">
             <a  href="#photo1" class="photoNav">Back to Top</a>              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>

          <div id="section120" class="section">
             <a  href="#photo1" class="photoNav">Back to Top</a>             
          </div>

      </full-page>
  </div>
</template>

<script>

export default {
  name: 'Photos',
  metaInfo: {
    title: 'Photos' // set a title
  },
  data () {
    return {
      options: {
        licenseKey: '08F6AFDB-F75D4F5A-AE124C87-3D28719F',
        menu: '#menu',
        anchors: ['loading', 'photo1', 'photo2', 'photo3', 'photo4', 'photo5', 'photo6', 'photo7', 'photo8', 'photo9', 'photo10', 'photo11', 'photo12', 'photo13', 'photo14', 'photo15', 'photo16', 'photo17', 'photo18', 'photo19', 'photo20', 'photo21', 'photo22', 'photo23', 'photo24', 'photo25', 'photo26', 'photo27', 'photo28', 'photo29', 'photo30', 'photo31', 'photo32', 'photo33', 'photo34'],
        slidesNavigation: true,
        controlArrows: true,
        scrollOverflow: true,
        lazyLoading: false,
        onLeave: this.onLeave,
        afterLoad: this.afterLoad
      }
    }
  },
  methods: {
    afterLoad (origin, destination, direction) {
      if (destination.index === 0) {
        this.$refs.fullpagePhotos.api.moveSectionDown()
      }
    },
    onLeave (origin, destination, direction) {
      if (destination.index === 0) {
        document.getElementById('stzHeaderTitleArt').classList.add('titleArt-Hidden')
        document.getElementById('stzHeaderTitleArt').classList.remove('logo')
      }
      if (origin.index === 1 && destination === 'up') {
        document.getElementById('stzHeaderTitleArt').classList.add('titleArt-Hidden')
        document.getElementById('stzHeaderTitleArt').classList.remove('logo')
      }
      // Photo page loading
      if (destination.index === 88 || destination.index === 121) {
        document.getElementById('section88').classList.add('loadImage')
        document.getElementById('section89').classList.add('loadImage')
        document.getElementById('section90').classList.add('loadImage')
        document.getElementById('section91').classList.add('loadImage')
        document.getElementById('section92').classList.add('loadImage')
        document.getElementById('section93').classList.add('loadImage')
        document.getElementById('section94').classList.add('loadImage')
        document.getElementById('section95').classList.add('loadImage')
        document.getElementById('section96').classList.add('loadImage')
        document.getElementById('section97').classList.add('loadImage')
        document.getElementById('section98').classList.add('loadImage')
        document.getElementById('section99').classList.add('loadImage')
        document.getElementById('section100').classList.add('loadImage')
        document.getElementById('section101').classList.add('loadImage')
        document.getElementById('section102').classList.add('loadImage')
        document.getElementById('section103').classList.add('loadImage')
        document.getElementById('section104').classList.add('loadImage')
        document.getElementById('section105').classList.add('loadImage')
        document.getElementById('section106').classList.add('loadImage')
        document.getElementById('section107').classList.add('loadImage')
        document.getElementById('section108').classList.add('loadImage')
        document.getElementById('section109').classList.add('loadImage')
        document.getElementById('section110').classList.add('loadImage')
        document.getElementById('section111').classList.add('loadImage')
        document.getElementById('section112').classList.add('loadImage')
        document.getElementById('section113').classList.add('loadImage')
        document.getElementById('section114').classList.add('loadImage')
        document.getElementById('section115').classList.add('loadImage')
        document.getElementById('section116').classList.add('loadImage')
        document.getElementById('section117').classList.add('loadImage')
        document.getElementById('section118').classList.add('loadImage')
        document.getElementById('section119').classList.add('loadImage')
        document.getElementById('section120').classList.add('loadImage')
      }
      if (destination.index === 2) {
        document.getElementById('section88').classList.add('loadImage')
      }
      if (destination.index === 3) {
        document.getElementById('section89').classList.add('loadImage')
      }
      if (destination.index === 4) {
        document.getElementById('section90').classList.add('loadImage')
      }
      if (destination.index === 5) {
        document.getElementById('section91').classList.add('loadImage')
      }
      if (destination.index === 6) {
        document.getElementById('section92').classList.add('loadImage')
      }
      if (destination.index === 7) {
        document.getElementById('section93').classList.add('loadImage')
      }
      if (destination.index === 8) {
        document.getElementById('section94').classList.add('loadImage')
      }
      if (destination.index === 9) {
        document.getElementById('section95').classList.add('loadImage')
      }
      if (destination.index === 10) {
        document.getElementById('section96').classList.add('loadImage')
      }
      if (destination.index === 11) {
        document.getElementById('section97').classList.add('loadImage')
      }
      if (destination.index === 12) {
        document.getElementById('section98').classList.add('loadImage')
      }
      if (destination.index === 13) {
        document.getElementById('section99').classList.add('loadImage')
      }
      if (destination.index === 14) {
        document.getElementById('section100').classList.add('loadImage')
      }
      if (destination.index === 15) {
        document.getElementById('section101').classList.add('loadImage')
      }
      if (destination.index === 16) {
        document.getElementById('section102').classList.add('loadImage')
      }
      if (destination.index === 17) {
        document.getElementById('section103').classList.add('loadImage')
      }
      if (destination.index === 18) {
        document.getElementById('section104').classList.add('loadImage')
      }
      if (destination.index === 19) {
        document.getElementById('section105').classList.add('loadImage')
      }
      if (destination.index === 20) {
        document.getElementById('section106').classList.add('loadImage')
      }
      if (destination.index === 21) {
        document.getElementById('section107').classList.add('loadImage')
      }
      if (destination.index === 22) {
        document.getElementById('section108').classList.add('loadImage')
      }
      if (destination.index === 23) {
        document.getElementById('section109').classList.add('loadImage')
      }
      if (destination.index === 24) {
        document.getElementById('section110').classList.add('loadImage')
      }
      if (destination.index === 25) {
        document.getElementById('section111').classList.add('loadImage')
      }
      if (destination.index === 26) {
        document.getElementById('section112').classList.add('loadImage')
      }
      if (destination.index === 27) {
        document.getElementById('section113').classList.add('loadImage')
      }
      if (destination.index === 28) {
        document.getElementById('section114').classList.add('loadImage')
      }
      if (destination.index === 29) {
        document.getElementById('section115').classList.add('loadImage')
      }
      if (destination.index === 30) {
        document.getElementById('section116').classList.add('loadImage')
      }
      if (destination.index === 31) {
        document.getElementById('section117').classList.add('loadImage')
      }
      if (destination.index === 32) {
        document.getElementById('section118').classList.add('loadImage')
      }
      if (destination.index === 33) {
        document.getElementById('section119').classList.add('loadImage')
      }
      if (destination.index === 34) {
        document.getElementById('section120').classList.add('loadImage')
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import "../styles/Photos.scss";
</style>



// WEBPACK FOOTER //
// src/components/Photos.vue